"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullBrandName = exports.Brand = void 0;
var Brand;
(function (Brand) {
    Brand["BK"] = "BK";
    Brand["LTW"] = "LTW";
    Brand["PLK"] = "PLK";
    Brand["TH"] = "TH";
    Brand["FHS"] = "FHS";
})(Brand = exports.Brand || (exports.Brand = {}));
var FullBrandName;
(function (FullBrandName) {
    FullBrandName["Popeyes"] = "Popeyes Louisiana Chicken";
    FullBrandName["TimHortons"] = "Tim Hortons";
    FullBrandName["BurgerKing"] = "Burger King";
    FullBrandName["FirehouseSubs"] = "Firehouse Subs";
    FullBrandName["LoveThatWing"] = "Love That Wing";
})(FullBrandName = exports.FullBrandName || (exports.FullBrandName = {}));
//# sourceMappingURL=brand.js.map